import React from "react"
import { Portal } from 'react-portal';
import { KeenSliderWrapper } from "./KeenSliderWrapper";

const ImageSliderOverlay = props => {
    const { images, initialIndex, onClose, onPrev, onNext, isOpen } = props

    const [slider, setSlider] = React.useState()
    const [currentSlide, setCurrentSlide] = React.useState(initialIndex)

    const keenSliderOptions = {
        loop: true,
        initial: initialIndex,
        slideChanged: s => setCurrentSlide(s.details().relativeSlide),
        className: "image-slider-overlay keen-slider"
    }

    React.useEffect(() => {
        if(slider && isOpen)
            slider.resize()
    }, [isOpen, slider])

    const handleNextClick = () => {
        if(onNext)
            onNext()
        slider.next()
    }

    const handlePrevClick = () => {
        if(onPrev)
            onPrev()
        slider.prev()
    }

    const sliderInitialized = sliderObject => {
        if(!slider) {
            setSlider(sliderObject)
        }
    }
    
    const cleanUp = () => {
        document.querySelector("body").classList.remove("no-scroll", "no-scroll--overlay")
        setSlider(null)
        setCurrentSlide(null)
    }

    React.useEffect(() => {
        if(!isOpen) {
            cleanUp()
        }else{            
            document.querySelector("body").classList.add("no-scroll", "no-scroll--overlay")
        }
    }, [isOpen])

    // Portal renders the component at the end of the body
    return isOpen && <Portal node={document && document.body}>
        <div className="image-slider-overlay">
            <div className="image-slider-overlay__content">
                <i className="icon icon-cancel image-slider-overlay__close" onClick={onClose}></i>
                <KeenSliderWrapper options={keenSliderOptions} onInit={sliderInitialized}>
                    {images.map((imageSrc, i) => 
                        <div className="keen-slider__slide" key={i+"image-slider-overlay"}>
                            <img src={imageSrc} />
                        </div>
                    )}
                </KeenSliderWrapper>
                <i className="icon icon-chevron-left image-slider-overlay__left" onClick={handlePrevClick}></i>
                <i className="icon icon-chevron-right image-slider-overlay__right" onClick={handleNextClick}></i>
                <div className="image-slider-overlay__count">{currentSlide+1}/{images.length}</div>
            </div>
        </div>
    </Portal>
}

export default ImageSliderOverlay;